import { PAGE_COOKIE_POLICY_EMBED, PAGE_COPYRIGHT_POLICY_EMBED, PAGE_OPEN_SOURCE_ATTRIBUTION_EMBED, PAGE_PRIVACY_POLICY_EMBED, PAGE_TERMS_OF_SERVICE_EMBED, PAGE_PRIVACY_NOTICE_CA_EMBED, PAGE_COOKIE_POLICY, PAGE_COPYRIGHT_POLICY, PAGE_PRIVACY_POLICY, PAGE_TERMS_OF_SERVICE, PAGE_PRIVACY_NOTICE_CA, PAGE_TRAVEL_TERMS_OF_SERVICE, PAGE_TRAVEL_TERMS_OF_SERVICE_EMBED, PAGE_TRAVEL_REGISTRATION, PAGE_TRAVEL_CONDITIONS, PAGE_TRAVEL_REGISTRATION_EMBED, PAGE_TRAVEL_CONDITIONS_EMBED, PAGE_SPECIFIED_COMMERCIAL_TRANSACTIONS, PAGE_SPECIFIED_COMMERCIAL_TRANSACTIONS_EMBED, PAGE_PRIMEPRO_TERMS_OF_SERVICE, PAGE_PRIMEPRO_TERMS_OF_SERVICE_EMBED, PAGE_PHOTO_USAGE_RIGHTS, PAGE_EXTERNAL_ACCEPTANCE_POLICY } from '@store/constants/routes';
import { URL_TERMS_JAPAN_ADDENDUM, URL_TERMS_JAPAN_ADDENDUM_EMBED, URL_PRIVACY_JAPAN_ADDENDUM, URL_PRIVACY_JAPAN_ADDENDUM_EMBED } from '@store/constants/urls';
// Web legal layout side menu links.
export var websiteLinks = {
  'en-us': [{
    titleKey: 'terms-of-service',
    href: PAGE_TERMS_OF_SERVICE
  }, {
    titleKey: 'privacy-policy',
    href: PAGE_PRIVACY_POLICY
  }, {
    titleKey: 'cookie-policy',
    href: PAGE_COOKIE_POLICY
  }, {
    titleKey: 'copyright-policy',
    href: PAGE_COPYRIGHT_POLICY
  }, {
    titleKey: 'external-acceptance-policy',
    href: PAGE_EXTERNAL_ACCEPTANCE_POLICY
  }, {
    titleKey: 'photo-usage-rights',
    href: PAGE_PHOTO_USAGE_RIGHTS
  }],
  'ja-jp': [{
    titleKey: 'terms-of-service',
    href: PAGE_TERMS_OF_SERVICE
  }, {
    titleKey: 'primepro-terms-of-service',
    href: PAGE_PRIMEPRO_TERMS_OF_SERVICE
  }, {
    titleKey: 'travel-terms-of-service',
    href: PAGE_TRAVEL_TERMS_OF_SERVICE
  }, {
    titleKey: 'travel-registration',
    href: PAGE_TRAVEL_REGISTRATION
  }, {
    titleKey: 'travel-conditions',
    href: PAGE_TRAVEL_CONDITIONS
  }, {
    titleKey: 'privacy-policy',
    href: PAGE_PRIVACY_POLICY
  }, {
    titleKey: 'cookie-policy',
    href: PAGE_COOKIE_POLICY
  }, {
    titleKey: 'specified-commercial-transactions',
    href: PAGE_SPECIFIED_COMMERCIAL_TRANSACTIONS
  }]
}; // Replace these linkKey's with the web platforms URL.
// Allows for legal markdown to be shared and still link to the correct page.

export var pageReplacements = [{
  linkKey: /privacy-policy-page-key/g,
  location: PAGE_PRIVACY_POLICY
}, {
  linkKey: /copyright-policy-page-key/g,
  location: PAGE_COPYRIGHT_POLICY
}, {
  linkKey: /cookie-policy-page-key/g,
  location: PAGE_COOKIE_POLICY
}, {
  linkKey: /terms-of-service-page-key/g,
  location: PAGE_TERMS_OF_SERVICE
}, {
  linkKey: /privacy-notice-california-page-key/g,
  location: PAGE_PRIVACY_NOTICE_CA
}, {
  linkKey: /travel-tos-page-key/g,
  location: PAGE_TRAVEL_TERMS_OF_SERVICE
}, {
  linkKey: /terms-japan-addendum-page-key/g,
  location: URL_TERMS_JAPAN_ADDENDUM
}, {
  linkKey: /privacy-japan-addendum-page-key/g,
  location: URL_PRIVACY_JAPAN_ADDENDUM
}]; // Embedded web view legal layout top menu links.

export var embedLinks = {
  'en-us': [{
    titleKey: 'terms-of-service',
    href: PAGE_TERMS_OF_SERVICE_EMBED
  }, {
    titleKey: 'privacy-policy',
    href: PAGE_PRIVACY_POLICY_EMBED
  }, {
    titleKey: 'cookie-policy',
    href: PAGE_COOKIE_POLICY_EMBED
  }, {
    titleKey: 'copyright-policy',
    href: PAGE_COPYRIGHT_POLICY_EMBED
  }, {
    titleKey: 'open-source-attribution',
    href: PAGE_OPEN_SOURCE_ATTRIBUTION_EMBED
  }],
  'ja-jp': [{
    titleKey: 'terms-of-service',
    href: PAGE_TERMS_OF_SERVICE_EMBED
  }, {
    titleKey: 'primepro-terms-of-service',
    href: PAGE_PRIMEPRO_TERMS_OF_SERVICE_EMBED
  }, {
    titleKey: 'travel-terms-of-service',
    href: PAGE_TRAVEL_TERMS_OF_SERVICE_EMBED
  }, {
    titleKey: 'travel-registration',
    href: PAGE_TRAVEL_REGISTRATION_EMBED
  }, {
    titleKey: 'travel-conditions',
    href: PAGE_TRAVEL_CONDITIONS_EMBED
  }, {
    titleKey: 'privacy-policy',
    href: PAGE_PRIVACY_POLICY_EMBED
  }, {
    titleKey: 'cookie-policy',
    href: PAGE_COOKIE_POLICY_EMBED
  }, {
    titleKey: 'open-source-attribution',
    href: PAGE_OPEN_SOURCE_ATTRIBUTION_EMBED
  }, {
    titleKey: 'specified-commercial-transactions',
    href: PAGE_SPECIFIED_COMMERCIAL_TRANSACTIONS_EMBED
  }]
}; // Replace these linkKey's with the embedded platforms URL.

export var embedPageReplacements = [{
  linkKey: /privacy-policy-page-key/g,
  location: PAGE_PRIVACY_POLICY_EMBED
}, {
  linkKey: /copyright-policy-page-key/g,
  location: PAGE_COPYRIGHT_POLICY_EMBED
}, {
  linkKey: /cookie-policy-page-key/g,
  location: PAGE_COOKIE_POLICY_EMBED
}, {
  linkKey: /terms-of-service-page-key/g,
  location: PAGE_TERMS_OF_SERVICE_EMBED
}, {
  linkKey: /privacy-notice-california-page-key/g,
  location: PAGE_PRIVACY_NOTICE_CA_EMBED
}, {
  linkKey: /travel-tos-page-key/g,
  location: PAGE_TRAVEL_TERMS_OF_SERVICE_EMBED
}, {
  linkKey: /terms-japan-addendum-page-key/g,
  location: URL_TERMS_JAPAN_ADDENDUM_EMBED
}, {
  linkKey: /privacy-japan-addendum-page-key/g,
  location: URL_PRIVACY_JAPAN_ADDENDUM_EMBED
}];